"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTION_ENDPOINT_MAP = exports.ENDPOINT_MAP = void 0;
exports.ENDPOINT_MAP = {
    Band: '/bands',
    Album: '/albums',
    MusicAlbum: '/music_albums',
    Audio: '/audio',
    Award: '/awards',
    Event: '/events',
    EventSeries: '/event_series',
    Image: '/images',
    Institution: '/institutions',
    Movie: '/movies',
    MusicalPeriod: '/musical_periods',
    Person: '/people',
    Publication: '/publications',
    PublicationItem: '/publication_items',
    Record: '/records',
    Reference: '/references',
    Song: '/songs',
    Tag: '/tags',
    Venue: '/venues',
    Video: '/videos',
};
exports.CONNECTION_ENDPOINT_MAP = {
    Person: '/change_request_person_connections',
    default: '/change_request_connections',
};
